

























import Vue from 'vue'

export default Vue.extend({
  methods: {
    addImageHandler() {
      this.$store.commit('modalStates/setShowModalAddImage', true)
      this.$store.commit('modalStates/setShowAddElementGuide', false)
      this.$emit('close')
    }
  }
})
